module.exports = __webpack_public_path__ + "img/icon3.d0fee550.png";